export class QuestionnaireGroup {
	id: number = null
	title: string = null
	discription: string = null
	questionnaires: Questionnaire[] = []

	constructor(questionnaire_group: any = null, questionnaires: any[] = [], questionnaire_options: any[] = []){
		if(!questionnaire_group){
			return;
		}
		this.id = questionnaire_group.id
		this.title = questionnaire_group.title
		this.discription = questionnaire_group.discription
		this.questionnaires = questionnaires.map((x: any) => new Questionnaire(x, questionnaire_options)).sort((a, b) => a.sort_no - b.sort_no);
	}
}

export class Questionnaire {
	id: number = null
	questionnaire_group_id: number = null
	sort_no: number = null
	question_text: string = null
	answer_type: number = 1
	max_point: number = 5

	questionnaire_options: QuestionnaireOption[] = []

	constructor(questionnaire: any = null, questionnaire_options: any[] = []){
		if(!questionnaire){
			return;
		}
		
		this.id = questionnaire.id
		this.questionnaire_group_id = questionnaire.questionnaire_group_id
		this.sort_no = questionnaire.sort_no
		this.question_text = questionnaire.question_text
		this.answer_type = questionnaire.answer_type
		this.max_point = questionnaire.max_point
		this.questionnaire_options = questionnaire_options.filter((x: any) => x.questionnaire_id == questionnaire.id).map((x: any) => new QuestionnaireOption(x)).sort((a, b) => a.sort_no - b.sort_no);
	}
}

export class QuestionnaireOption {
	id: number = null
	questionnaire_id: number = null
	sort_no: number = null
	option_text: string = null

	constructor(questionnaire_option: any = null){
		if(!questionnaire_option){
			return;
		}
		this.id = questionnaire_option.id
		this.questionnaire_id = questionnaire_option.questionnaire_id
		this.sort_no = questionnaire_option.sort_no
		this.option_text = questionnaire_option.option_text
	}
}

